import { render, staticRenderFns } from "./ThreeTierSystem.vue?vue&type=template&id=157f5383&scoped=true&"
import script from "./ThreeTierSystem.vue?vue&type=script&lang=js&"
export * from "./ThreeTierSystem.vue?vue&type=script&lang=js&"
import style0 from "./ThreeTierSystem.vue?vue&type=style&index=0&id=157f5383&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f5383",
  null
  
)

export default component.exports